import { toastr } from "react-redux-toastr";
import { DEFAULT_GET_CONFIG } from "../../config/rest";
import { CLEAR_UNRETURNED_AMOUNT, FLAG_GETTING_UNRETURNED_AMOUNT, GET_UNRETURNED_AMOUNT } from "../types";
import { isErrorResponse } from "../../utils/error-handlers";
import { generateSalesSessionUnreturnedAmountEndpoint } from "../../config/endpoints";

const flagGettingUnreturnedAmounts = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_UNRETURNED_AMOUNT,
    payload: flag,
  });

const getSalesSessionUnreturnedAmounts =
  async ({ salesSessionId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingUnreturnedAmounts(true));
      const url = generateSalesSessionUnreturnedAmountEndpoint(salesSessionId);
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      // check if it is an error response
      await isErrorResponse(response, null, dispatch);
      const unreturnedAmount = await response.json();
      await dispatch({
        type: GET_UNRETURNED_AMOUNT,
        payload: { content: unreturnedAmount },
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingUnreturnedAmounts(false));
    }
  };

const clearUnreturnedAmounts = () => (dispatch) =>
  dispatch({
    type: CLEAR_UNRETURNED_AMOUNT,
  });

export {
    getSalesSessionUnreturnedAmounts,
    clearUnreturnedAmounts
}